import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import HandleDeleteVeridasApp from './HandleDeleteVeridasApp';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * Component to handle the effect of reloading the page. The user is shown a confirmation message to verify whether they truly want to leave the page.
 * If they confirm, all registered information (INE/Passport and the selfie) is deleted. Otherwise, the information is preserved and the process continues.
 * @param model getInvitationById: Model that contains all the information of the invitation.
 *
 */
const useHandleBeforeUnload = ({ getInvitationById, validationId }) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isRedirected, setIsRedirected] = useState(false);

    const { handleDelete, handleDeleteStorage, handleGetUrl } = HandleDeleteVeridasApp({ getInvitationById , validationId });

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };

        const handleUnload = () => {
            sessionStorage.setItem('redirectToPage', 'true');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleUnload);
        };
    }, []);

    useEffect(() => {
        const redirect = sessionStorage.getItem('redirectToPage');

        if (redirect) {
            const url = handleGetUrl();

            sessionStorage.removeItem('redirectToPage');

            handleDelete?.();

            toast.warn(t("all_the_recorded_information_was_lost"));
            navigate(url);
            handleDeleteStorage();
            setIsRedirected(true);
        }
    }, [navigate, handleDelete]);

    return { isRedirected };

};

export default useHandleBeforeUnload
